import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../searchresults/Address";
import PropertyDeed from "./PropertyDeed";
import getPersonName from "../common/Name";
import getBusinessName from "../common/Business";

class Property extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    const node = this.props.node;
    const internalId = _.get(node, "$.internalID");
    if (node !== undefined) {
      const entities = _.get(node, "record[0].entities[0].entity");
      const deedNode = _.get(node, "record[0].deed[0]");
      if (entities !== undefined) {
        const propRows = [];
        _.forEach(entities, (entity, index) => {
          const propetyType = _.get(entity, "entityType[0]._");
          if (propetyType === "Property") {
            propRows.push(
              <Table.Row
                key={`prop_${internalId}_row1_${this.props.index}_${index}`}
              >
                <Table.HeaderCell
                  colSpan={4}
                  className="report-sub-sub-section-header"
                >
                  <center>Property</center>
                </Table.HeaderCell>
              </Table.Row>
            );
            propRows.push(
              <Table.Row
                key={`prop_${internalId}_row2_${this.props.index}_${index}`}
              >
                <Table.Cell>
                  <span className="text-bold">Address:</span>
                </Table.Cell>
                <Table.Cell>
                  <Address {...this.props} addressNode={entity.address[0]} />
                </Table.Cell>
              </Table.Row>
            );
          } else if (propetyType === "Borrower") {
            propRows.push(
              <Table.Row
                key={`Bor_${internalId}_row1_${this.props.index}_${index}`}
              >
                <Table.HeaderCell
                  colSpan={4}
                  className="report-sub-sub-section-header"
                >
                  <center>Borrower</center>
                </Table.HeaderCell>
              </Table.Row>
            );
            const names = _.get(entity, "names[0].name");
            if (names !== undefined) {
              _.forEach(names, (name, nameIndex) => {
                const companyName = _.get(name, "companyName[0]._", "");
                if (companyName !== "") {
                  propRows.push(
                    <Table.Row
                      key={`Nam_${internalId}_row1_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell colSpan={3}>N/A</Table.Cell>
                    </Table.Row>
                  );
                  propRows.push(
                    <Table.Row
                      key={`Nam_${internalId}_row2_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Company Name:</span>
                      </Table.Cell>
                      <Table.Cell colSpan={3}>
                        {getBusinessName(companyName, this.props)}
                      </Table.Cell>
                    </Table.Row>
                  );
                } else {
                  propRows.push(
                    <Table.Row
                      key={`Nam_${internalId}_row_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell colSpan={3}>
                        {getPersonName(
                          _.get(name, "first[0]._", ""),
                          "",
                          _.get(name, "last[0]._", ""),
                          this.props
                        )}
                      </Table.Cell>
                    </Table.Row>
                  );
                }
              });
            }
          } else if (propetyType === "Buyer") {
            const buyRows = [];
            propRows.push(
              <Table.Row
                key={`Buy_${internalId}_row1_${this.props.index}_${index}`}
              >
                <Table.HeaderCell
                  colSpan={4}
                  className="report-sub-sub-section-header"
                >
                  <center>Buyer</center>
                </Table.HeaderCell>
              </Table.Row>
            );
            const names = _.get(entity, "names[0].name");
            if (names !== undefined) {
              _.forEach(names, (name, nameIndex) => {
                const companyName = _.get(name, "companyName[0]._", "");
                if (companyName !== "") {
                  buyRows.push(
                    <Table.Row
                      key={`buy_${internalId}_Nam_row1_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell>N/A</Table.Cell>
                    </Table.Row>
                  );
                  buyRows.push(
                    <Table.Row
                      key={`buy_${internalId}_Nam_row2_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell colSpan={2}>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                    </Table.Row>
                  );
                  buyRows.push(
                    <Table.Row
                      key={`buy_${internalId}_Nam_row3_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Company Name:</span>
                      </Table.Cell>
                      <Table.Cell>
                        {getBusinessName(companyName, this.props)}
                      </Table.Cell>
                    </Table.Row>
                  );
                } else {
                  buyRows.push(
                    <Table.Row
                      key={`buy_${internalId}_Nam_row_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell>
                        {getPersonName(
                          _.get(name, "first[0]._", ""),
                          "",
                          _.get(name, "last[0]._", ""),
                          this.props
                        )}
                      </Table.Cell>
                    </Table.Row>
                  );
                }
              });
            }
            propRows.push(
              <Table.Row
                key={`Buy_${internalId}_row2_${this.props.index}_${index}`}
              >
                {entity.address && entity.address.length > 0 && (
                  <Table.Cell>
                    <Table className={"table-no-border-and-padding"}>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <span className="text-bold">Address:</span>
                          </Table.Cell>
                          <Table.Cell>
                            <Address
                              {...this.props}
                              addressNode={entity.address[0]}
                            />
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                )}

                <Table.Cell
                  colSpan={entity.address && entity.address.length > 0 ? 1 : 2}
                >
                  <Table className={"table-no-border-and-padding"}>
                    <Table.Body>{buyRows}</Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          } else if (propetyType === "Seller") {
            const buyRows = [];
            propRows.push(
              <Table.Row
                key={`Sel_${internalId}_row1_${this.props.index}_${index}`}
              >
                <Table.HeaderCell
                  colSpan={4}
                  className="report-sub-sub-section-header"
                >
                  <center>Seller</center>
                </Table.HeaderCell>
              </Table.Row>
            );
            const names = _.get(entity, "names[0].name");
            if (names !== undefined) {
              _.forEach(names, (name, nameIndex) => {
                const companyName = _.get(name, "companyName[0]._", "");
                if (companyName !== "") {
                  buyRows.push(
                    <Table.Row
                      key={`sel_${internalId}_Nam_row1_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell>N/A</Table.Cell>
                    </Table.Row>
                  );
                  buyRows.push(
                    <Table.Row
                      key={`sel_${internalId}_Nam_row2_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell colSpan={2}>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                    </Table.Row>
                  );
                  buyRows.push(
                    <Table.Row
                      key={`sel_${internalId}_Nam_row3_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Company Name:</span>
                      </Table.Cell>
                      <Table.Cell>
                        {getBusinessName(companyName, this.props)}
                      </Table.Cell>
                    </Table.Row>
                  );
                } else {
                  buyRows.push(
                    <Table.Row
                      key={`sel_${internalId}_Nam_row_${this.props.index}_${nameIndex}`}
                    >
                      <Table.Cell>
                        <span className="text-bold">Name:</span>
                      </Table.Cell>
                      <Table.Cell>
                        {getPersonName(
                          _.get(name, "first[0]._", ""),
                          "",
                          _.get(name, "last[0]._", ""),
                          this.props
                        )}
                      </Table.Cell>
                    </Table.Row>
                  );
                }
              });
            }
            propRows.push(
              <Table.Row
                key={`Sel_${internalId}_row2_${this.props.index}_${index}`}
              >
                {entity.address && entity.address.length > 0 && (
                  <Table.Cell>
                    <Table className={"table-no-border-and-padding"}>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>
                            <span className="text-bold">Address:</span>
                          </Table.Cell>
                          <Table.Cell>
                            <Address
                              {...this.props}
                              addressNode={entity.address[0]}
                            />
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                )}

                <Table.Cell
                  colSpan={entity.address && entity.address.length > 0 ? 1 : 2}
                >
                  <Table className={"table-no-border-and-padding"}>
                    <Table.Body>{buyRows}</Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });

        rows.push(
          <Table.Row key={`property_row_${this.props.index}_${internalId}`}>
            <Table.Cell>
              <Table className={"table-no-padding"}>
                <Table.Body>{propRows}</Table.Body>
              </Table>
            </Table.Cell>
            <Table.Cell>
              <PropertyDeed deedNode={deedNode} />
            </Table.Cell>
          </Table.Row>
        );
      }
    }
    return (
      <Table>
        <Table.Body>{rows}</Table.Body>
      </Table>
    );
  }
}

export default Property;



// WEBPACK FOOTER //
// ./src/components/reports/Property.js